import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import { makeStyles } from "@material-ui/core/styles";
import {
  get_for_customer,
  show_for,
  get_promotion_prize,
} from "../../../utils";
import { formatPrice } from "../../../utils/formatPrice";

const useStyles = makeStyles((theme) => ({
  productBox: {
    position: "relative",
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
    padding: "10px",
    textAlign: "center",
    backgroundColor: "#fff",
  },
  imgWrapper: {
    position: "relative",
    "& img": {
      width: "100%",
      height: "auto",
      borderRadius: "8px",
    },
  },
  outOfStockLabel: {
    position: "absolute",
    top: "10px",
    left: "10px",
    backgroundColor: "rgba(255, 0, 0, 0.85)", // Semi-transparent red
    color: "white",
    padding: "8px 12px",
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "uppercase",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Subtle shadow for depth
    zIndex: 2,
    pointerEvents: "none", // Ensure it's not clickable
  },
  productDetail: {
    marginTop: "10px",
    "& h6": {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "5px",
      color: "#333",
    },
    "& h4": {
      fontSize: "18px",
      color: "#393230",
      marginBottom: "10px",
    },
  },
  rating: {
    marginBottom: "10px",
  },
  cartInfo: {
    position: "absolute",
    top: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column",
    "& button, & a": {
      marginBottom: "5px",
    },
  },
  productButtons: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
    "& button, & a": {
      padding: "8px 12px",
      backgroundColor: "#393230",
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      borderRadius: "5px",
      textDecoration: "none",
      display: "inline-block",
      textAlign: "center",
      "&:disabled": {
        backgroundColor: "#ddd",
        cursor: "not-allowed",
      },
    },
  },
}));

const ProductListItem = ({
  product,
  symbol,
  user,
  onAddToCartClicked,
  onAddToWishlistClicked,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const onOpenModal = () => setOpen(true);

  const onCloseModal = () => setOpen(false);

  const minusQty = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const plusQty = () => {
    if (quantity < product.stock_quantity) {
      setQuantity(quantity + 1);
    }
  };

  const changeQty = (e) => setQuantity(parseInt(e.target.value));

  let RatingStars = [];
  for (let i = 0; i < product.rating; i++) {
    RatingStars.push(<i className="fa fa-star" key={i} />);
  }

  return (
    <div className={classes.productBox}>
      <div className={classes.imgWrapper}>
        <div className="front">
          <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}>
            <img
              src={
                product && product.product_images[0]
                  ? product.product_images[0].image
                  : "Image"
              }
              className="img-fluid"
              alt={product.product_name}
            />
          </Link>
        </div>
        {product.stock_quantity === 0 && (
          <div className={classes.outOfStockLabel}>Out of Stock</div>
        )}
        <div className={classes.cartInfo}>
          {get_for_customer(
            user,
            <>
              <button
                title="Add to cart"
                onClick={() =>
                  onAddToCartClicked({
                    product,
                    quantity: quantity,
                  })
                }
                disabled={product.stock_quantity === 0}
              >
                <i className="fa fa-shopping-cart" aria-hidden="true" />
              </button>
              <a
                href="javascript:void(0)"
                title="Add to Wishlist"
                onClick={() =>
                  onAddToWishlistClicked({
                    product,
                    quantity: quantity,
                  })
                }
              >
                <i className="fa fa-heart" aria-hidden="true" />
              </a>
            </>
          )}
          <a
            href="javascript:void(0)"
            data-toggle="modal"
            data-target="#quick-view"
            title="Quick View"
            onClick={onOpenModal}
          >
            <i className="fa fa-search" aria-hidden="true" />
          </a>
        </div>
      </div>
      <div className={classes.productDetail}>
        <div className={classes.rating}>{RatingStars}</div>
        <Link to={`${process.env.PUBLIC_URL}/product/${product._id}`}>
          <h6>{product.product_name}</h6>
        </Link>
        <h4>
          {/* {symbol} */}
          {formatPrice(product.product_price)}
        </h4>
        <h6>Stock Quantity: {product.stock_quantity}</h6>
      </div>
      <Modal open={open} onClose={onCloseModal} center>
        <div
          className="modal-dialog modal-lg modal-dialog-centered p-4"
          role="document"
        >
          <div className="modal-content quick-view-modal">
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6  col-xs-12">
                  <div className="quick-view-img">
                    <img
                      src={
                        product && product.product_images[0]
                          ? product.product_images[0].image
                          : "Image"
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col-lg-6 rtl-text">
                  <div className="product-right">
                    <h2> {product.product_name} </h2>
                    <h3>
                      {symbol}
                      {product.product_price}
                    </h3>
\                    <div className="border-product">
                      <h6 className="product-title">Product Details</h6>
                      <p>{product.product_discription.slice(0, 150)}</p>
                    </div>
                    {show_for(
                      ["member", "merchant"],
                      <div className="product-description border-product">
                        <h4 className="product-title">Promotion Prize</h4>
                        <div className="qty-box">
                          <h5>
                            {symbol}
                            {get_promotion_prize(product)}{" "}
                            <small className="text-muted">/ Item</small>
                          </h5>
                        </div>
                      </div>
                    )}
                    {show_for(
                      ["customer"],
                      <div className="product-description border-product">
                        <h6 className="product-title">Quantity</h6>
                        <div className="qty-box">
                          <div className="input-group">
                            <span className="input-group-prepend">
                              <button
                                type="button"
                                className="btn quantity-left-minus"
                                onClick={minusQty}
                                data-type="minus"
                                data-field=""
                                disabled={product.stock_quantity === 0}
                              >
                                <i className="fa fa-angle-left" />
                              </button>
                            </span>
                            <input
                              type="text"
                              name="quantity"
                              value={quantity}
                              onChange={changeQty}
                              className="form-control input-number"
                              disabled={product.stock_quantity === 0}
                            />
                            <span className="input-group-prepend">
                              <button
                                type="button"
                                className="btn quantity-right-plus"
                                onClick={plusQty}
                                data-type="plus"
                                data-field=""
                                disabled={product.stock_quantity === 0}
                              >
                                <i className="fa fa-angle-right" />
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className={classes.productButtons}>
                      {get_for_customer(
                        user,
                        <button
                          onClick={() =>
                            onAddToCartClicked({
                              product,
                              quantity: quantity,
                            })
                          }
                          disabled={product.stock_quantity === 0}
                        >
                          {product.stock_quantity > 0
                            ? "Add to cart"
                            : "Out of Stock"}
                        </button>
                      )}
                      <Link
                        to={`${process.env.PUBLIC_URL}/product/${product._id}`}
                      >
                        View detail
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ProductListItem;
